import { addHandlerClickOnCompareIcon } from './compare';

const sendReview = async (form) => {
  window.loaderShow('.product__content');
  const url = '/api/review/add/';
  const formData = new FormData(form);

  let iterator = 0;
  [...formData.entries()].forEach((keyValueArr) => {
    if (keyValueArr[0] === 'photos[]') {
      formData.set(`photos[${iterator}]`, keyValueArr[1]);
      iterator++;
    }
  });
  iterator = 0;
  formData.delete('photos[]');

  const isRecaptchaDisabled = process.env.RECAPTCHA_NO_CHECK || false;
  // eslint-disable-next-line
  if (grecaptcha && !isRecaptchaDisabled) {
    // eslint-disable-next-line
    const token = await grecaptcha.execute(process.env.RECAPTCHA_TOKEN);
    formData.append('g-recaptcha-response', token);
  }

  try {
    const respone = await fetch(url, {
      method: 'POST',
      body: formData,
    });
    const result = await respone.json();

    window.loaderHide('.product__content');
    window.popupOpenUniversalForm('', 'Отзыв добавлен и будет опубликован после модерации');

    return result;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    window.loaderHide('.product__content');
    window.popupOpenUniversalForm(null, 'Что-то пошло не так, попробуйте позже');

    return null;
  }
};

const initFormReview = () => {
  const forms = document.querySelectorAll('.goodscard-reviews__form');

  if (forms && forms.length) {
    forms.forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        await sendReview(e.target);

        queueMicrotask(() => {
          e.target.reset();
          const attachedFilesBlock = form.querySelector('.goodscard-reviews__attached-block');
          if (attachedFilesBlock) {
            attachedFilesBlock.innerHTML = '';
            attachedFilesBlock.classList.add('_empty');
          }
        });
      });
    });
  }
};

const exampleFormHandler = async (e) => {
  e.preventDefault();
  const isValid = e.target.validationForm();
  if (!isValid) return null;

  window.loaderShow('.product__content');

  const form = e.target;
  const formData = new FormData(form);
  const URL = form.action;

  try {
    const rawResponse = await fetch(URL, {
      method: 'POST',
      body: formData,
    });

    const response = await rawResponse.text();

    window.loaderHide('.product__content');
    window.popupOpenUniversalForm('', 'Пример монтажа добавлен и будет опубликован после модерации');

    e.target.reset();
    return response;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);

    window.loaderHide('.product__content');
    window.popupOpenUniversalForm(null, 'Что-то пошло не так, попробуйте позже');

    return null;
  }
};

const initExampleForm = () => {
  const formExampleAdd = document.querySelector('.iblock_add');
  if (formExampleAdd) {
    formExampleAdd.addEventListener('submit', exampleFormHandler);
  }
};

const fetchExamplePage = async (URL) => {
  try {
    const rawResponse = await fetch(URL);

    const response = await rawResponse.text();
    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const initExamplePagen = () => {
  const pagenWrapper = document.querySelector('.example-pagination');
  if (pagenWrapper) {
    pagenWrapper.querySelectorAll('[data-href]').forEach((link) => {
      link.addEventListener('click', async () => {
        window.loaderShow('.product__content');

        const content = await fetchExamplePage(link.dataset.href);

        const container = document.querySelector('#tab-container-example');
        if (content && container) {
          container.innerHTML = content;
          window.initForm();
          window.exampleTabInit();
          window.initExamplesProductSlider();
        }

        window.loaderHide('.product__content');
      });
    });
  }
};

const likesFetch = async (data) => {
  const formData = new FormData();
  const keys = Object.keys(data);
  keys.forEach((key) => {
    formData.append(`${key}`, data[key]);
  });
  const URL = '/bitrix/components/bitrix/rating.vote/vote.ajax.php';

  try {
    const rawResponse = await fetch(
      URL,
      {
        method: 'POST',
        body: formData,
      },
    );

    const responseToString = await rawResponse.text();
    const response = await JSON.parse(responseToString.replaceAll("'", '"'));
    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return null;
  }
};

const raitingInit = () => {
  const wrapperRating = document.querySelectorAll('.examples-product__rating');
  if (wrapperRating && wrapperRating.length) {
    wrapperRating.forEach((wrapper) => {
      const sessId = wrapper.querySelector('[name="sessid"]').value;
      const entityId = wrapper.querySelector('[name="entity_id"]').value;
      const ratingItems = wrapper.querySelectorAll('.examples-product__rating-item');
      if (ratingItems && ratingItems.length) {
        ratingItems.forEach((item) => {
          item.addEventListener('click', async () => {
            const data = {
              sessid: sessId,
              RATING_VOTE: 'Y',
              RATING_RESULT: 'Y',
              RATING_VOTE_TYPE_ID: 'IBLOCK_ELEMENT',
              RATING_VOTE_ENTITY_ID: entityId,
              RATING_VOTE_ACTION: item.classList.contains('bx-rating-yes') ? 'plus' : 'minus',
            };

            const result = await likesFetch(data);

            if (result) {
              const yesCount = wrapper.querySelector('.bx-rating-yes-count');
              yesCount.innerText = result.resultPositiveVotes;

              const noCount = wrapper.querySelector('.bx-rating-no-count');
              noCount.innerText = result.resultNegativeVotes;
            }
          });
        });
      }
    });
  }
};

const initStepBack = () => {
  const tabContainer = document.querySelector('#tab-container-example');
  if (!tabContainer) return;
  const stepBackButton = tabContainer.querySelector('.step-back');

  if (stepBackButton) {
    stepBackButton.addEventListener('click', () => {
      const examplesBlock = tabContainer.querySelector('.examples-product');
      const formBlock = tabContainer.querySelector('.product-add');

      if (examplesBlock && formBlock) {
        formBlock.classList.add('_hidden');

        examplesBlock.classList.remove('_hidden');
      }
    });
  }
};

const InitAddExampleButton = () => {
  const tabContainer = document.querySelector('#tab-container-example');
  if (!tabContainer) return;
  const AddExampleButton = tabContainer.querySelector('.examples-product__btn');

  if (AddExampleButton) {
    AddExampleButton.addEventListener('click', () => {
      const examplesBlock = tabContainer.querySelector('.examples-product');
      const formBlock = tabContainer.querySelector('.product-add');

      if (examplesBlock && formBlock) {
        formBlock.classList.remove('_hidden');

        examplesBlock.classList.add('_hidden');
      }
    });
  }
};

const InitExampleBlock = () => {
  const tabContainer = document.querySelector('#tab-container-example');
  const examplesBlock = tabContainer.querySelector('.examples-product');
  const formBlock = tabContainer.querySelector('.product-add');

  if (examplesBlock && formBlock) {
    const tabContent = tabContainer.querySelector('.examples-product__content');
    if (tabContent) {
      formBlock.classList.add('_hidden');
    } else {
      examplesBlock.classList.add('_hidden');
    }
  }
};

const fetchData = async (data) => {
  const url = new URL(window.location.href);
  url.searchParams.append('ajax-catalog-element', 'Y');
  url.searchParams.append('tab', data.blockName);

  try {
    const rawResponse = await fetch(url);

    const responseToString = await rawResponse.text();

    return responseToString;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const initNewNodes = () => {
  window.initProductSliderNew();
  window.initBuyScript();
  addHandlerClickOnCompareIcon();
  window.addHandlerClickOnFavoriteIcon();
  window.lazyUpdate();
};

const clickHandler = async (e) => {
  let elem = null;
  if (e.target.classList.contains('_tabs-item')) elem = e.target;
  else elem = e.target.closest('._tabs-item');

  if (elem.classList.contains('_init')) return;

  window.loaderShow('.product__content');

  const data = {
    blockName: elem.dataset.block,
  };

  const content = await fetchData(data);
  const container = document.querySelector(`#tab-container-${elem.dataset.block}`);

  if (content && container) container.innerHTML = content;

  if (elem.dataset.block === 'another_prod') {
    initNewNodes();
  }

  if (elem.dataset.block === 'reviews') {
    initFormReview();
    window.popupsInit();
    window.attachedFilesInit();
    window.initReviewsLightBox();
    window.attachFilesInit();
    window.reviewsPaginationInit();
    window.fullScreenViewer();
  }

  if (elem.dataset.block === 'example') {
    window.initForm();
    window.exampleTabInit();
    window.initExamplesProductSlider();
  }

  elem.classList.add('_init');

  window.loaderHide('.product__content');
};

const initAjaxLoadingTabs = () => {
  const listLink = document.querySelectorAll('[data-entity="ajax-loading"]');
  if (listLink.length > 0) {
    listLink.forEach((link) => {
      link.addEventListener('click', clickHandler);
    });
  }
};
initAjaxLoadingTabs();

const exampleTabInit = () => {
  initExampleForm();
  initFormReview();
  raitingInit();
  initExamplePagen();
  initStepBack();
  InitAddExampleButton();
  InitExampleBlock();
};

window.exampleTabInit = exampleTabInit;
window.initFormReview = initFormReview;
window.initAjaxLoadingTabs = initAjaxLoadingTabs;
